'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { TimePickerColumns } from "./time-picker-columns";
import { TimePickerSelect } from "./time-picker-select";
import { jsx as _jsx } from "react/jsx-runtime";
// 288 = 24h × (60/5min) — the largest option count where a flat dropdown is still
// usable. Beyond this (e.g. minuteInterval=1 → 1440 options) the column picker is
// used because scrolling through 1440 items in a single list is impractical.
var MAX_FLAT_OPTIONS = 288;

/**
 * Entry point component — decides which internal variant to render.
 * The `variant` prop can force a specific layout; otherwise it is auto-detected.
 */
export var TimePicker = function TimePicker(props) {
  var _props$minuteInterval = props.minuteInterval,
    minuteInterval = _props$minuteInterval === void 0 ? 15 : _props$minuteInterval,
    variant = props.variant;
  var totalOptions = 24 * (60 / minuteInterval);

  // Explicit variant wins. When omitted, switch to columns if total options exceed threshold.
  var useColumns = variant === 'columns' || !variant && totalOptions > MAX_FLAT_OPTIONS;
  if (useColumns) {
    return /*#__PURE__*/_jsx(TimePickerColumns, _objectSpread({}, props));
  }
  return /*#__PURE__*/_jsx(TimePickerSelect, _objectSpread({}, props));
};